import { defaultServer, docSearchApi } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';

// Helper to get root URL by removing any trailing slashes or paths
const getRootUrl = (url: string) => {
  try {
    const urlObj = new URL(url);
    return `${urlObj.protocol}//${urlObj.host}`;
  } catch (e) {
    return url.split('/')[0]; // Fallback to just taking everything before first slash
  }
};

export const healthEndpoint = {
  server: {
    ...defaultServer,
    url: getRootUrl(String(process.env.REACT_API_DEFAULT_URL)),
  },
  path: '',
  description: 'Health check endpoint for main API',
};

export const healthSearchEndpoint = {
  server: {
    ...docSearchApi,
    url: getRootUrl(String(process.env.REACT_DOC_SEARCH_API_URL)),
  },
  path: '',
  description: 'Health check endpoint for search API',
};

const healthEndpointExec = getExecEndpoint<HealthEndpointDef>(healthEndpoint);
const healthSearchEndpointExec =
  getExecEndpoint<HealthEndpointDef>(healthSearchEndpoint);

export const endpointHealthGET = async () => {
  return await healthEndpointExec<'GET'>({
    method: 'GET',
  });
};

export const endpointHealth2GET = async () => {
  return await healthSearchEndpointExec<'GET'>({
    method: 'GET',
  });
};

export interface HealthEndpointDef {
  endpoint: typeof healthEndpoint | typeof healthSearchEndpoint;
  methods: {
    GET: {
      response: {
        status: string;
        message?: string;
      };
    };
  };
}
